import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueAcceptancePageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        acceptance: {
          title: "智能攻防靶场验收看板",
          subtitle:
            "只展示当前可验证的 RedBlue 与 AIRange 真实证据；未建立口径的指标明确标记为未验证。",
          loading: "正在读取验收证据",
          refresh: "刷新验收证据",
          unverifiedAlert: "部分指标尚未具备可复现的验收证据，不能按成功或失败推断。",
          generatedAt: "证据生成时间",
          notProvided: "未提供",
          notReturned: "未返回",
          contractFailed: "验收接口返回的数据不符合当前合同",
          loadFailed: "验收证据读取失败",
          columns: {
            metric: "验收指标",
            status: "状态",
            target: "目标",
            observed: "实测",
            unit: "单位",
            coverage: "覆盖范围",
            reason: "判定依据",
          },
          details: {
            definition: "指标定义",
            evidence: "指标证据",
            supportingEvidence: "支撑证据",
          },
          stats: {
            metricCount: "指标总数",
            met: "已满足",
            notMet: "未满足",
            unverified: "未验证",
          },
          fields: {
            source: "证据来源",
            sourceType: "来源类型",
            endpoint: "接口",
            observedAt: "观测时间",
            requestId: "业务 request_id",
            traceId: "追踪 trace_id",
            errorCode: "错误码",
            errorMessage: "错误信息",
            facts: "事实明细",
            factKey: "事实键",
            factLabel: "事实名称",
            factValue: "事实值",
          },
          status: {
            met: "已满足",
            notMet: "未满足",
            unverified: "未验证",
          },
          evidence: {
            verified: "已验证证据",
            unverified: "未验证证据",
          },
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        acceptance: {
          title: "Intelligent Cyber Range Acceptance",
          subtitle:
            "Shows only verifiable RedBlue and AIRange evidence; metrics without an established method remain unverified.",
          loading: "Loading acceptance evidence",
          refresh: "Refresh acceptance evidence",
          unverifiedAlert:
            "Some metrics do not yet have reproducible acceptance evidence and must not be inferred as met or not met.",
          generatedAt: "Evidence generated",
          notProvided: "Not provided",
          notReturned: "Not returned",
          contractFailed: "The acceptance response violates the current contract",
          loadFailed: "Failed to load acceptance evidence",
          columns: {
            metric: "Metric",
            status: "Status",
            target: "Target",
            observed: "Observed",
            unit: "Unit",
            coverage: "Coverage",
            reason: "Decision basis",
          },
          details: {
            definition: "Definition",
            evidence: "Metric evidence",
            supportingEvidence: "Supporting evidence",
          },
          stats: {
            metricCount: "Metrics",
            met: "Met",
            notMet: "Not met",
            unverified: "Unverified",
          },
          fields: {
            source: "Evidence source",
            sourceType: "Source type",
            endpoint: "Endpoint",
            observedAt: "Observed at",
            requestId: "Business request_id",
            traceId: "Trace trace_id",
            errorCode: "Error code",
            errorMessage: "Error message",
            facts: "Facts",
            factKey: "Fact key",
            factLabel: "Fact label",
            factValue: "Fact value",
          },
          status: {
            met: "Met",
            notMet: "Not met",
            unverified: "Unverified",
          },
          evidence: {
            verified: "Verified evidence",
            unverified: "Unverified evidence",
          },
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        acceptance: {
          title: "インテリジェント演習場受入ダッシュボード",
          subtitle:
            "RedBlue と AIRange の検証可能な実証だけを表示し、基準未確立の指標は未検証として扱います。",
          loading: "受入証跡を読み込んでいます",
          refresh: "受入証跡を更新",
          unverifiedAlert:
            "再現可能な受入証跡がまだない指標があります。達成または未達とは推定しません。",
          generatedAt: "証跡生成時刻",
          notProvided: "未提供",
          notReturned: "未返却",
          contractFailed: "受入 API の応答が現在の契約に違反しています",
          loadFailed: "受入証跡の読み込みに失敗しました",
          columns: {
            metric: "受入指標",
            status: "状態",
            target: "目標",
            observed: "実測",
            unit: "単位",
            coverage: "カバレッジ",
            reason: "判定根拠",
          },
          details: {
            definition: "指標定義",
            evidence: "指標証跡",
            supportingEvidence: "補足証跡",
          },
          stats: {
            metricCount: "指標総数",
            met: "達成",
            notMet: "未達",
            unverified: "未検証",
          },
          fields: {
            source: "証跡ソース",
            sourceType: "ソース種別",
            endpoint: "エンドポイント",
            observedAt: "観測時刻",
            requestId: "業務 request_id",
            traceId: "追跡 trace_id",
            errorCode: "エラーコード",
            errorMessage: "エラーメッセージ",
            facts: "事実詳細",
            factKey: "事実キー",
            factLabel: "事実名",
            factValue: "事実値",
          },
          status: {
            met: "達成",
            notMet: "未達",
            unverified: "未検証",
          },
          evidence: {
            verified: "検証済み証跡",
            unverified: "未検証証跡",
          },
        },
      },
    },
  },
};
